//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _application from './application';
import _deploy from './deploy';
import _deviceManagement from './deviceManagement';
import _file from './file';
import _identity from './identity';
import _importNamespace from './importNamespace';
import _inventory from './inventory';
import _item from './item';
import _metadata from './metadata';
import _namespace from './namespace';
import _order from './order';
import _organization from './organization';
import _rulesEngine from './rulesEngine';
import _transaction from './transaction';
export const application = _application;
export const deploy = _deploy;
export const deviceManagement = _deviceManagement;
export const file = _file;
export const identity = _identity;
export const importNamespace = _importNamespace;
export const inventory = _inventory;
export const item = _item;
export const metadata = _metadata;
export const namespace = _namespace;
export const order = _order;
export const organization = _organization;
export const rulesEngine = _rulesEngine;
export const transaction = _transaction;
export default {application, deploy, deviceManagement, file, identity, importNamespace, inventory, item, metadata, namespace, order, organization, rulesEngine, transaction};

